















































import FirstStep from './components/FirstStep.vue';
import SecondStep from './components/SecondStep.vue';
import { mapActions, mapGetters } from 'vuex';
import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import users from '@/store/modules/users';
import clients from '@/store/modules/clients';
import Client from '@/models/Client';

@Component({
  components: {
    FirstStep,
    SecondStep,
  },
})
export default class Setup extends Vue {
  public name = 'setup';

  private step = 1;
  private loading = true;
  private error = false;
  private client: any = {};
  private allClients = [];
  private options: any = [];
  private steps = [
    {
      value: 1,
      text: 'Step 1 - Store client data in DB',
    },
    {
      value: 2,
      text: 'Step 2 - Folder and permission settings through Beanstalk',
    },
    {
      value: 3,
      text: 'Step 3 - Create subdomains in Digital Ocean',
    },
    {
      value: 4,
      text: 'Step 4 - Create project in Bitbucket',
    },
    {
      value: 5,
      text: 'Step 5 - Create fork of config project',
    },
    {
      value: 6,
      text: 'Step 6 - Create fork of server project',
    },
    {
      value: 7,
      text: 'Step 7 - Create fork of delivery project',
    },
    {
      value: 8,
      text: 'Step 8 - Create fork of client project',
    },
    {
      value: 9,
      text: 'Step 9 - Set MangoPay and DeliveryService',
    },
    {
      value: 10,
      text: 'Step 10 - Generate security parameters',
    },
    {
      value: 11,
      text: `Step 11 - Shell script for clone and config 'Config' repo`,
    },
    {
      value: 12,
      text: `Step 12 - Shell script for clone and config 'Server' repo`,
    },
    {
      value: 13,
      text: `Step 13 - Shell script for clone and config 'Delivery' repo`,
    },
    {
      value: 14,
      text: `Step 14 - Shell script for clone and config 'Client' repo`,
    },
    {
      value: 15,
      text: `Step 15 - Create database and import tables structure`,
    },
  ];

  private firstStepKey = 0;
  private secondStepKey = 0;
  private clientSelectKey = 0;
  private stepSelectKey = 0;

  private form: any = {
    client: '',
    step: this.step,
  };

  private async created() {
    try {
      if (this.$route.params.id) {
        const response = await clients.getOneClient({
          id: this.$route.params.id,
        });
        this.editClient(response.client);
      }

      const user = await users.getLoggedUser();
      if (!user) {
        await users.logout();
        this.$router.push({ name: 'login' });
      } else {
        await this.prepareComponent();
      }
    } catch (error) {
      return error;
    }
  }

  private async prepareComponent() {
    try {
      this.allClients = await clients.getClients();
      this.options = this.prepareOptions(this.allClients);
      this.loading = false;
      this.$forceUpdate();
    } catch (err) {
      return err;
    }
  }

  private prepareOptions(clientsSource: Client[]) {
    return clientsSource.map((client) => {
      return {
        value: client,
        text: client.restaurantName,
      };
    });
  }

  private editClient(event: any) {
    this.clientSelectKey++;
    this.stepSelectKey++;
    if (event) {
      this.client = event;
      this.step = this.client.setupStatus
        ? this.client.setupStatus.step
        : this.step;
      this.form.step = this.step;
      this.form.client = this.client;
      if (this.step > 7) {
        this.secondStepKey++;
      } else {
        this.firstStepKey++;
      }
    }
  }

  private editStep(event: any) {
    this.clientSelectKey++;
    this.stepSelectKey++;
    if (event) {
      this.step = event;
      if (this.step > 7) {
        this.secondStepKey++;
      } else {
        this.firstStepKey++;
      }
    }
  }

  private moveForward(event: any) {
    this.clientSelectKey++;
    this.stepSelectKey++;
    if (event) {
      this.client = event;
      this.step = 8;
      this.secondStepKey++;
    }
  }
}
